import React, { useRef } from 'react';

const TrustLogos = () => {
  const scrollRef = useRef(null);

  const partners = [
    { name: 'AWS Cloud', icon: 'fab fa-aws', color: '#FF9900' },
    { name: 'Stripe Payments', icon: 'fab fa-stripe', color: '#635BFF' },
    { name: 'Google Cloud AI', icon: 'fab fa-google', color: '#4285F4' },
    { name: 'PaperLoan Fintech', icon: 'fas fa-landmark', color: '#00D4FF' },
    { name: 'HungryTop Commerce', icon: 'fas fa-shopping-bag', color: '#6C63FF' },
    { name: 'React & Next.js', icon: 'fab fa-react', color: '#61DAFB' },
    { name: 'NVIDIA AI Labs', icon: 'fas fa-microchip', color: '#76B900' },
    { name: 'Kubernetes DevOps', icon: 'fas fa-dharmachakra', color: '#326CE5' },
    { name: 'PostgreSQL Enterprise', icon: 'fas fa-database', color: '#336791' },
    { name: 'Docker Cloud', icon: 'fab fa-docker', color: '#2496ED' },
  ];

  // Quadruple for infinite smooth marquee sequence
  const marqueeList = [...partners, ...partners, ...partners, ...partners];

  const handleManualScroll = (direction) => {
    if (scrollRef.current) {
      const isMobile = window.innerWidth < 640;
      const step = isMobile ? 220 : 340;
      const scrollAmount = direction === 'left' ? -step : step;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section
      style={{
        padding: '20px 0',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        background: 'linear-gradient(180deg, rgba(6, 8, 22, 0.9) 0%, rgba(10, 15, 36, 0.95) 100%)',
        position: 'relative',
        zIndex: 2,
        overflow: 'hidden',
      }}
    >
      <div
        className="ht-container trust-logos-header-row"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '14px',
          gap: '12px',
        }}
      >
        {/* Subtitle Badge */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1, minWidth: 0 }}>
          <span
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              background: '#00D4FF',
              boxShadow: '0 0 8px #00D4FF',
              flexShrink: 0,
            }}
          ></span>
          <span
            style={{
              fontSize: 'clamp(0.66rem, 2.5vw, 0.74rem)',
              fontWeight: 700,
              color: '#94A3B8',
              letterSpacing: '0.12em',
              textTransform: 'uppercase',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              lineHeight: 1.3,
            }}
          >
            POWERING NEXT-GEN ENTERPRISE & ECOSYSTEM PARTNERS
          </span>
        </div>

        {/* Arrow Scroller Buttons */}
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
          <button
            onClick={() => handleManualScroll('left')}
            aria-label="Scroll Left"
            title="Scroll Left"
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'rgba(0, 212, 255, 0.1)',
              border: '1px solid rgba(0, 212, 255, 0.35)',
              color: '#00D4FF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.78rem',
              transition: 'all 0.25s ease',
              boxShadow: '0 2px 10px rgba(0, 212, 255, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#6C63FF';
              e.currentTarget.style.borderColor = '#6C63FF';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.boxShadow = '0 0 14px rgba(108, 99, 255, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.35)';
              e.currentTarget.style.color = '#00D4FF';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 212, 255, 0.2)';
            }}
          >
            <i className="fas fa-chevron-left"></i>
          </button>

          <button
            onClick={() => handleManualScroll('right')}
            aria-label="Scroll Right"
            title="Scroll Right"
            style={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              background: 'rgba(0, 212, 255, 0.1)',
              border: '1px solid rgba(0, 212, 255, 0.35)',
              color: '#00D4FF',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.78rem',
              transition: 'all 0.25s ease',
              boxShadow: '0 2px 10px rgba(0, 212, 255, 0.2)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#6C63FF';
              e.currentTarget.style.borderColor = '#6C63FF';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.boxShadow = '0 0 14px rgba(108, 99, 255, 0.6)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)';
              e.currentTarget.style.borderColor = 'rgba(0, 212, 255, 0.35)';
              e.currentTarget.style.color = '#00D4FF';
              e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 212, 255, 0.2)';
            }}
          >
            <i className="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>

      {/* Marquee Track with Responsive Mask Gradient */}
      <div
        ref={scrollRef}
        className="trust-marquee-wrapper"
        style={{
          display: 'flex',
          overflowX: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          width: '100%',
          userSelect: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        <div
          className="luxury-marquee-track"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            width: 'max-content',
            animation: 'luxuryMarquee 32s linear infinite',
            willChange: 'transform',
            padding: '4px 16px',
          }}
        >
          {marqueeList.map((partner, idx) => (
            <div
              key={idx}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                padding: '6px 16px',
                borderRadius: '9999px',
                background: 'rgba(15, 23, 42, 0.85)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid rgba(255, 255, 255, 0.12)',
                color: '#F8FAFC',
                fontSize: '0.8rem',
                fontWeight: 700,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                letterSpacing: '-0.01em',
                transition: 'all 0.25s ease',
                cursor: 'pointer',
                flexShrink: 0,
                boxShadow: '0 4px 14px rgba(0, 0, 0, 0.3)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(108, 99, 255, 0.22)';
                e.currentTarget.style.borderColor = '#00D4FF';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(15, 23, 42, 0.85)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.12)';
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.1)';
              }}
            >
              <div
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.06)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <i className={partner.icon} style={{ color: partner.color, fontSize: '1.15rem' }}></i>
              </div>
              <span>{partner.name}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .trust-marquee-wrapper {
          mask-image: linear-gradient(to right, transparent, black 6%, black 94%, transparent);
          -webkit-mask-image: linear-gradient(to right, transparent, black 6%, black 94%, transparent);
        }
        @media (max-width: 640px) {
          .trust-marquee-wrapper {
            mask-image: linear-gradient(to right, transparent, black 2%, black 98%, transparent) !important;
            -webkit-mask-image: linear-gradient(to right, transparent, black 2%, black 98%, transparent) !important;
          }
        }
        div::-webkit-scrollbar {
          display: none;
        }
        @keyframes luxuryMarquee {
          0% {
            transform: translateX(0%);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .luxury-marquee-track:hover {
          animation-play-state: paused !important;
        }
      `}</style>
    </section>
  );
};

export default TrustLogos;


